<template>

  <div class="row" ref="shipping_methodsForm">

    <div class="col-xs-8 offset-xs-2 col-md-8 offset-md-2 col-sm-12">
      <ValidationObserver v-slot="{ handleSubmit }" ref="formValidator">

        <card>
          <div slot="header">
            <h4 class="card-title">
              {{ formTitle }}
            </h4>
          </div>

          <div class="card-body">
            <ValidationProvider
              vid="name"
              rules="required"
              name="The name"
              v-slot="{ passed, failed,errors }">
              <fg-input type="text"
                        :error="failed ? errors[0]: null"
                        label="Name"
                        name="name"
                        fou
                        v-model="formData.name">
              </fg-input>
            </ValidationProvider>

            <fg-text type="text"
                     label="Description"
                     name="description"
                     fou
                     :rows="5"
                     v-model="formData.description">
            </fg-text>

            <ValidationProvider
              vid="code"
              rules="required"
              name="The Code"
              v-slot="{ passed, failed,errors }">
              <fg-input type="text"
                        :disabled="editMode === true"
                        :error="failed ? errors[0]: null"
                        label="Code"
                        name="code"
                        fou
                        v-model="formData.code">
              </fg-input>
            </ValidationProvider>

            <fg-text  type="text"
                     label="Fee"
                     name="fee"
                     fou
                     :rows="5"
                     v-model="formData.fee">
            </fg-text>

            <!-- //IS ACTIVE-->
            <div class="form-group pt-4">
              <label>Is Active</label>&nbsp;
              <l-switch v-model="formData.is_active">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
              </l-switch>
            </div>
          </div>

          <div class="card-footer text-right">
            <l-button :disabled="entityNotFoundError || submitting" @click.prevent="handleSubmit(submit)"
                      nativeType="submit"
                      type="info" wide>Submit
            </l-button>&nbsp;

            <l-button @click="$router.push('/shipping_methods/list')" type="danger" wide>Cancel
            </l-button>
          </div>
        </card>


      </ValidationObserver>

    </div>

  </div>
</template>
<script>
import {extend} from "vee-validate";
import {Option, Select} from 'element-ui';
import { Switch as LSwitch} from "@/components";


extend("required", {
  message: "{_field_} is required"
});

export default {

  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    LSwitch,
  },

  data() {
    return {
      editMode: false,
      loader: {},
      id: undefined,

      formTitle: "",
      entityNotFoundError: false,
      submitting: false,

      formData: {
        name: "",
        description: "",
        code: "",
        fee: "",
        is_active: true
      },
    };
  },
  mounted() {

    this.loader = this.$loading.show({
      container: this.$refs.shipping_methodsForm
    });

    this.id = this.$route.params['id'];

    if (this.id !== undefined) {
      this.editMode = true;
      this.formTitle = "Edit Shipping method";
      this.getShippingMethod();
    } else {
      this.editMode = false;
      this.formTitle = "Add Shipping Method";
      this.loader.hide();
    }
  },


  methods: {

    getShippingMethod() {
      let data = {
          'id' : this.id,
      };
      this.axios.post("shipping_methods/get", data).then((response) => {
        this.formData = response.data;
        this.loader.hide();
      }).catch((error) => {
        if (error.response.status === 404) {
          this.entityNotFoundError = true;
          this.$notify({
            message: "Shipping Method Not Found",
            timeout: 2000,
            type: 'danger'
          });
          this.loader.hide();

        } else {
          console.error(error);
        }
      })
    },


    submit() {
      let request;
      let successMessage;
      this.submitting = true;

      if (this.editMode === true) {
        request = this.axios.put("shipping_methods/update/" + this.id, this.formData);
        successMessage = "Shipping Methods Item Updated Successfully";
      } else {
        request = this.axios.post("shipping_methods/create", this.formData);
        successMessage = "Shipping Methods Item Added Successfully";
      }

      request.then((response) => {
        this.$notify({
          message: successMessage,
          timeout: 1000,
          type: 'success'
        })
        this.$router.push("/shipping_methods/list");
      }).catch((error) => {
        if (error.response.status === 422) {
          this.$refs.formValidator.setErrors(error.response.data.errors);
        } else {
          console.log(error.response)
        }
      }).finally(() => {
        this.submitting = false;
      });
    }

  }
}
</script>

<style>
</style>
